/**
 * Subscriptions Fixture.
 * Spec: lmm-wiki/wiki/orbit-specs/done/subscriptions-admin.md
 *
 * Shape per Spec — flach (kein verschachteltes `user.email`/`product.amount`).
 */

const STATUSES = ['active', 'past_due', 'trialing', 'cancelled', 'active', 'paused'];
const PROVIDERS = ['stripe', 'paypal'];
const PLANS = [
  { sku: 'pro-monthly', label: 'Pro · Monatlich', amount: 1999, billingInterval: 'month' },
  { sku: 'business-yearly', label: 'Business · Jährlich', amount: 19900, billingInterval: 'year' },
  { sku: 'starter-monthly', label: 'Starter · Monatlich', amount: 499, billingInterval: 'month' },
];

function persist() {
  if (typeof window === 'undefined') return null;
  if (!window.__ORBIT_SUBSCRIPTIONS_DB__) {
    window.__ORBIT_SUBSCRIPTIONS_DB__ = { cancelled: {}, immediate: {} };
  }
  return window.__ORBIT_SUBSCRIPTIONS_DB__;
}

export function subscriptionsFixture({ status = '', provider = '', userId = '' } = {}) {
  const db = persist();
  const now = Date.now();
  const all = [];
  for (let i = 0; i < 50; i += 1) {
    const id = 50_000 + i;
    const rawStatus = STATUSES[i % STATUSES.length];
    const cancelled = db?.cancelled?.[id];
    const cancelImmediate = db?.immediate?.[id];
    const stat = cancelled ? (cancelImmediate ? 'cancelled' : rawStatus) : rawStatus;
    const cancelAtPeriodEnd = cancelled && !cancelImmediate;
    const plan = PLANS[i % PLANS.length];
    const createdAt = new Date(now - (60 + i * 5) * 86_400_000).toISOString();
    const currentPeriodStart = new Date(now - (i % 30) * 86_400_000).toISOString();
    const currentPeriodEnd = new Date(now + ((30 - (i % 30)) * 86_400_000)).toISOString();
    const minimumTermUntil = i % 3 === 0
      ? new Date(now + ((180 - (i % 180)) * 86_400_000)).toISOString()
      : null;
    const trialEndAt = stat === 'trialing'
      ? new Date(now + ((7 - (i % 7)) * 86_400_000)).toISOString()
      : null;
    const trialEndingEmittedAt = stat === 'trialing' && i % 4 === 0
      ? new Date(now - 86_400_000).toISOString()
      : null;
    all.push({
      id,
      userId: 4700 + (i % 30),
      userEmail: `customer${4700 + (i % 30)}@example.com`,
      provider: PROVIDERS[i % PROVIDERS.length],
      providerSubscriptionId: i % 7 === 0 ? null : `sub_${plan.sku}_${id}`,
      status: stat,
      unitAmount: plan.amount,
      currency: 'EUR',
      billingInterval: plan.billingInterval,
      currentPeriodStart,
      currentPeriodEnd,
      trialEndAt,
      trialEndingEmittedAt,
      cancelAtPeriodEnd,
      minimumTermUntil,
      cancelledAt: cancelled ? new Date(now - 60_000).toISOString() : null,
      endedAt: cancelImmediate ? new Date(now - 60_000).toISOString() : null,
      createdAt,
      // Convenience für Filter (nicht im Spec, aber lokal genutzt)
      sku: plan.sku,
      planLabel: plan.label,
    });
  }

  const filtered = all.filter((s) => {
    if (status && s.status !== status) return false;
    if (provider && s.provider !== provider) return false;
    if (userId && String(s.userId) !== String(userId)) return false;
    return true;
  });

  return { subscriptions: filtered };
}

export function cancelSubscriptionFixture({ id, immediate }) {
  const db = persist();
  if (db) {
    db.cancelled[id] = true;
    if (immediate) db.immediate[id] = true;
  }
  return { ok: true, immediate: !!immediate };
}
